export const cognitoGroups = {
    Admin: 'admin',
    Manager: 'manager',
};